module.exports = __webpack_public_path__ + "img/share.ed1ff29a.png";